// 탭을 새로 고쳐도 로그인이 유지되게 토큰을 sessionStorage 에 둔다 — 탭을 닫으면 사라진다.
// 저장소를 못 쓰면(사생활 모드 등) 보관만 건너뛴다. 플랫폼 세션 쿠키가 살아 있으면 재발급으로 다시 받는다
import { toIssuedToken, type IssuedToken } from '../domain/login';

const KEY = 'nnt.platform.session';
// 이 탭이 지금 무엇을 기다리는가 — 'login'(플랫폼 로그인 화면에 다녀오는 중) · 'out'(이 탭에서 로그아웃함)
const INTENT_KEY = 'nnt.platform.intent';

export type Intent = 'login' | 'out';

export function readIntent(): Intent | null {
  try {
    const value = globalThis.sessionStorage?.getItem(INTENT_KEY);
    return value === 'login' || value === 'out' ? value : null;
  } catch {
    return null; // silent-ok: 저장소를 못 쓰면 표식이 없는 것으로 본다 — 돌아온 토큰을 받지 않는 쪽(안전한 쪽)이다
  }
}

export function markIntent(intent: Intent | null): void {
  try {
    if (intent) globalThis.sessionStorage?.setItem(INTENT_KEY, intent);
    else globalThis.sessionStorage?.removeItem(INTENT_KEY);
  } catch {
    // silent-ok: 저장소를 못 쓰는 브라우저에서는 표식을 남기지 못한다 — readIntent 가 null 이라 돌아온 토큰은 받지 않고 플랫폼 세션 재발급으로 로그인된다
  }
}

export function loadKept(now: number): IssuedToken | null {
  try {
    const raw = globalThis.sessionStorage?.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as { token?: unknown; expiresAt?: unknown };
    if (typeof saved.expiresAt !== 'number' || saved.expiresAt <= now) return null;
    // 저장된 값도 바깥 입력이다 — 모양을 다시 본다
    const issued = toIssuedToken(saved.token, Math.ceil((saved.expiresAt - now) / 1000), now);
    return issued && { token: issued.token, expiresAt: saved.expiresAt };
  } catch {
    return null;
  }
}

export function keep(issued: IssuedToken | null): void {
  try {
    if (issued) globalThis.sessionStorage?.setItem(KEY, JSON.stringify(issued));
    else globalThis.sessionStorage?.removeItem(KEY);
  } catch {
    // silent-ok: 저장소를 못 쓰는 브라우저(사생활 모드 등)에서는 보관만 건너뛴다 — 로그인은 메모리의 세션으로 계속된다
  }
}
